import { mapGetters } from 'vuex'
import moment from 'moment'
import i18n from '@/plugins/vue-i18n'

const tarjetas = [
  {
    id: 'condiciones',
    title: i18n.t('mixins.reserva.condiciones'),
    image: 'condiciones.jpg'
  },
  {
    id: 'pago',
    title: i18n.t('mixins.reserva.pago'),
    image: 'pago.jpg'
  },
  {
    id: 'contrato',
    title: i18n.t('mixins.reserva.contrato'),
    image: 'contrato.jpg'
  },
  {
    id: 'scoring',
    title: i18n.t('mixins.reserva.scoring'),
    image: 'kyc.jpg'
  },
  {
    id: 'kyc',
    title: i18n.t('mixins.reserva.kyc'),
    image: 'kyc.jpg'
  },
  {
    id: 'documentacion',
    title: i18n.t('mixins.reserva.documentacion'),
    image: 'documentacion.jpg'
  },
  {
    id: 'validacionDocumentacion',
    title: i18n.t('mixins.reserva.validacionDocumentacion'),
    image: 'validacionDocumentacion.jpg'
  },
  {
    id: 'pbc',
    title: i18n.t('mixins.reserva.pbc'),
    image: 'pbc.jpg'
  }
]

export default {
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual',
      modulos: 'modulosOrdenes/modulos/getAll'
    }),
    tarjetasReserva () {
      let retorno = this.modulos.map(x => {
        let tarjeta = tarjetas.find(y => y.id === x.tipo)
        return {
          ...tarjeta,
          title: this.getTexto('modulos.' + x.tipo + (this.reserva.cod_tipo_operacion === 'ALQ' ? 'Alquiler' : ''))
        }
      })
      if (this.esPbc && !this.esComercial && !this.esAdministrador) {
        retorno = retorno.filter(x => x.id === 'pbc')
      }
      return retorno
    },
    textoPasoActual () {
      if (this.reserva.estado === 20) {
        return this.getTexto('reserva.completada') || this.$t('mixins.reserva.reservaTerminada')
      } else if ((this.reserva.estado === 10 || this.reserva.estado === 1) && (this.reserva.fechaLimite == null || moment().isBefore(this.reserva.fechaLimite))) {
        return this.getTexto('reserva.noCompletada') || this.$t('mixins.reserva.cumplimentaPasos')
      } else {
        return this.getTexto('reserva.noActiva') || this.$t('mixins.reserva.reservaNoActiva')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/reserva.js